import { inject, Injectable, Pipe, type PipeTransform } from '@angular/core';
import { StateCountryStore } from '@td/dictionaries';

@Pipe({ name: 'stateCountry', standalone: true })
@Injectable({ providedIn: 'root' })
export class StateCountryPipe implements PipeTransform {
  private readonly statesStore = inject(StateCountryStore);

  transform(id: unknown): string {
    if (typeof id !== 'string') {
      return '';
    }
    if (!id) {
      return '';
    }
    return this.statesStore.states().find((state) => state.id === id)?.stateName ?? id;
  }
}
